
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCalendarPeriodSelectorItem } from './base/new-calendar-period-selector-item';
import moment from 'moment';

export class DayPeriodSelectorItem extends NewCalendarPeriodSelectorItem {
    interval = NewPeriodSelectorInterval.Day;
    hasNavigation = true;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        const startDate = moment().startOf('day').toDate();
        const endDate = moment().endOf('day').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = startDate;
        periodFilter.endDate = endDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Day;

        return periodFilter;
    }

    getPreviousPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        const newStartDate = moment(currentFilter.startDate)
            .add(-1, 'day')
            .startOf('day')
            .toDate()
        const newEndDate = moment(currentFilter.startDate)
            .add(-1, 'day')
            .endOf('day')
            .toDate()

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Day;

        return periodFilter;
    }

    getNextPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        const newStartDate = moment(currentFilter.startDate)
            .add(1, 'day')
            .startOf('day')
            .toDate()
        const newEndDate = moment(currentFilter.startDate)
            .add(1, 'day')
            .endOf('day')
            .toDate()

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Day;

        return periodFilter;
    }
}
